
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ambassador-program",
      function () {
        return require("private-next-pages/ambassador-program.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ambassador-program"])
      });
    }
  